import { Vue } from 'vue-facing-decorator';

export default class EmailBrandingHelper extends Vue{
  public static EmailOperationalStatus = 'Operational';
  public static EmailBrokenStatus = 'Broken';
  public static EmailActiveStatus = 'Active';
  public static DomainPendingStatus = 'Pending';
  public static DomainVerifiedStatus = 'Verified';
  public static DomainBrokenStatus = 'Broken';
  public static DomainErrorStatus = 'Error';
  public static DomainNotVerifiedStatus = 'Not verified';
  public static DomainNameMaxLength = 253;
  public static EmailPrefixMaxLength = 64;
  public static ToasterTimeOut = 3000;
  public static LoaderTimeOut = 1000;
  public static DeleteDomainModal = 0;
  public static DeleteEmailAddressModal = 1;
  public static TotalEmailsLimit = 2;
  public static EmailDomainDrawerDefaultWidth = '40%';
  public static DefaultDomainName = 'ventla.io';
  public static VerifiedDomain = 1;
  public static DomainDrawer = 0;
  public static EmailDrawer = 1;
  public static DomainTooltipPlaceholderEmailAddress = 'example.com';
  public static DomainInfoString = 'domain';
}
